// extracted by mini-css-extract-plugin
export default {"Text-block":"HomePage_Text-block__p6ETe","Background":"HomePage_Background__XQgeh","Page__content":"HomePage_Page__content__LuZ6M"};